module.exports = __webpack_public_path__ + "static/media/app-celular.d6c0745c.svg";